var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.006,
    height: 27.98,
    viewBox: "0 0 28.006 27.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.891,
    y1: 0.815,
    x2: 0.177,
    y2: 0.301,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    "data-name": "Union 11",
    d: "M19305.5,27.98a1.405,1.405,0,0,1-1.4-1.4v-9a.4.4,0,0,0-.4-.4h-5.4a.4.4,0,0,0-.4.4v9a1.405,1.405,0,0,1-1.4,1.4h-3.762a3.5,3.5,0,0,1-3.467-3.5l-.053-7.877a2.664,2.664,0,0,1-2-1.629,2.753,2.753,0,0,1,.566-3L19298.551,1a3.5,3.5,0,0,1,4.906,0l.01,0,10.752,10.965a2.747,2.747,0,0,1,.572,3,2.675,2.675,0,0,1-2.061,1.638v7.867a3.494,3.494,0,0,1-3.461,3.5Zm-1.8-13.6a3.2,3.2,0,0,1,3.2,3.2v7.6h2.355a.683.683,0,0,0,.668-.7V15.24a1.4,1.4,0,0,1,1.4-1.4h.8l-10.66-10.868a.666.666,0,0,0-.93,0l-10.66,10.868h.795a1.4,1.4,0,0,1,1.4,1.4V24.48a.688.688,0,0,0,.668.7h2.355v-7.6a3.209,3.209,0,0,1,3.2-3.2Z",
    transform: "translate(-19287.002)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a10ae8b5920086f313d4a450f582e00e.svg";
export { ForwardRef as ReactComponent };